import { ACTIVE_COURIER_DETAIL_SORT_BY_STATUS } from '@src/pages/DeliveryDashboard/models/model-constants';
import PIEText from '@src/shared/components/PIEText';
import React, { FC } from 'react';
import CourierDetailOrderCard from '../CourierDetailOrderCard';
import { IOrder } from '@src/pages/DeliveryDashboard/models/model-interface';
import { PIEComponentUtil } from '@src/shared/components/PIEComponentUtil';
import UpcommingDeliveryInformation from './components/UpcommingDevliveryInformation';
import { useTranslation } from 'react-i18next';

interface ICourierUpcomingDeliveryProps {
  data: IOrder[];
  title: string;
}

export const CourierUpcomingDelivery: FC<ICourierUpcomingDeliveryProps> = ({
  data,
  title,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <PIEComponentUtil paddingTop="var(--xds-spacing-d)">
        <PIEText
          text={title}
          color="var(--xds-color-content-default)"
          size="var(--xds-font-size-14)"
        />
      </PIEComponentUtil>
      <PIEComponentUtil paddingTop="var(--xds-spacing-d)">
        <UpcommingDeliveryInformation
          comment={t('order.UPCOMING_DELIVERY_TITLE')}
        />
      </PIEComponentUtil>
      {data
        ?.sort(
          (a: IOrder, b: IOrder) =>
            ACTIVE_COURIER_DETAIL_SORT_BY_STATUS[a.status] -
            ACTIVE_COURIER_DETAIL_SORT_BY_STATUS[b.status]
        )
        .map((order: IOrder, index: number) => {
          return <CourierDetailOrderCard key={index} orderData={order} />;
        })}
    </>
  );
};
